import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItem,
  Typography,
  IconButton,
  Box,
  CircularProgress,
} from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import RefreshIcon from "@material-ui/icons/Refresh";
import Request from "../../../../../helpers/Request";

export default function LogsDisplay({ logs: initialLogs, id }) {
  const [open, setOpen] = useState(false);
  const [logs, setLogs] = useState(initialLogs);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
    handleRefresh();
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleRefresh = async () => {
    setIsRefreshing(true);
    const response = await Request("get", `/api/management/app-updates/gdzadm-dev/${id}`);
    if (response.data?.logs) {
      setLogs(response.data.logs);
    }
    setIsRefreshing(false);
  };

  return (
    <>
      <Button
        color="inherit"
        variant="text"
        size="small"
        onClick={handleClickOpen}
      >
        <VisibilityIcon sx={{ fontSize: "1rem" }} />
        Görüntüle
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        scroll="paper"
      >
        <DialogTitle>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            Log Kayıtları
            <IconButton
              onClick={handleRefresh}
              disabled={isRefreshing}
              size="small"
              style={{ marginLeft: "auto" }}
            >
              {isRefreshing ? <CircularProgress size={20} /> : <RefreshIcon />}
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          <List>
            {logs.map((log, index) => (
              <ListItem key={index}>
                <Typography variant="body2" style={{ fontFamily: "monospace" }}>
                  {log}
                </Typography>
              </ListItem>
            ))}
          </List>
        </DialogContent>
      </Dialog>
    </>
  );
}
